export default {
  api: {
    base: process.env.VUE_APP_API_BASE,
    timeout: 60000,
    version: '1.6',
    clientId: '1005',
    userId: '1a093eaae4e69f0a', // Test data
    privateKey:
      'f86560b37672ef6c102954b6b25c97f327ee40380be4d081c9b6fa183bd4f66c',
    date: '68',
    month: '67'
  },
  dynamic_link: {
    url: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK,
    link: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK_LINK,
    ofl: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK_OFL,
    apn: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK_APN,
    ibi: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK_IBI,
    isi: process.env.VUE_APP_FIREBASE_DYNAMIC_LINK_ISI,
    ius: 'jp.co.unerry.JoyfullCoupon'
  }
}
